var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHeartV2 = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon23424",
    "data-name": 23423441,
    viewBox: "0 0 40 36.65",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,42,22,40.1q-5.29-4.85-8.75-8.37a62.29,62.29,0,0,1-5.5-6.3,21.09,21.09,0,0,1-2.88-5A13.37,13.37,0,0,1,4,15.85,10.18,10.18,0,0,1,7,8.33a10.12,10.12,0,0,1,7.47-3,10.63,10.63,0,0,1,5.27,1.35A12.79,12.79,0,0,1,24,10.55a14.52,14.52,0,0,1,4.45-4A10.44,10.44,0,0,1,33.5,5.3a10.12,10.12,0,0,1,7.47,3,10.18,10.18,0,0,1,3,7.52,12.92,12.92,0,0,1-.83,4.55,20.46,20.46,0,0,1-2.87,5,61.22,61.22,0,0,1-5.5,6.3q-3.45,3.54-8.75,8.38Zm0-4q5.06-4.65,8.33-8a66.26,66.26,0,0,0,5.2-5.82,19.61,19.61,0,0,0,2.7-4.45,10.62,10.62,0,0,0,.77-3.9,7.37,7.37,0,0,0-2.1-5.42A7.25,7.25,0,0,0,33.5,8.3a8,8,0,0,0-4.75,1.58A11.13,11.13,0,0,0,25.2,14.3H22.75a11.06,11.06,0,0,0-3.5-4.4A7.9,7.9,0,0,0,14.5,8.3a7.29,7.29,0,0,0-5.4,2.12A7.41,7.41,0,0,0,7,15.85a10.57,10.57,0,0,0,.78,3.92,18.88,18.88,0,0,0,2.7,4.5A58.66,58.66,0,0,0,15.7,30.1Q19,33.4,24,38Z",
    transform: "translate(-4 -5.3)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeartV2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/heart_v2.710ca541.svg";
export { ForwardRef as ReactComponent };